import {
  isDesktop,
  isVRCompatible,
  isMobileVR,
  isGyroscopeSupported,
  isIpadNewOs, isIPad,
} from '../utils/device';

import { Features } from './constants';

const getChromeVersion = () => {
  const raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
  return raw ? parseInt(raw[2], 10) : false;
};

export default async (disableFeature) => {
  const supportsFullscreen = document.body.requestFullscreen ||
    document.body.webkitRequestFullscreen ||
    document.body.mozRequestFullScreen;

  const supportsGyroscope = await isGyroscopeSupported();
  const gyroscopeSupportViaLocalStorage = sessionStorage.getItem('gyroscopeCheck');

  const mobileVR = isMobileVR();

  if (!supportsFullscreen || mobileVR) {
    disableFeature(Features.FULLSCREEN);
  }

  if (!isDesktop() || isIpadNewOs()) {
    disableFeature(Features.AUTO_ROTATE);
  }

  if (!supportsGyroscope && gyroscopeSupportViaLocalStorage !== 'ON') {
    disableFeature(Features.GYROSCOPE);
  }

  if (supportsGyroscope || isVRCompatible()) {
    disableFeature(Features.VR_MODE);
  }

  if (isIpadNewOs() || isIPad()) {
    disableFeature(Features.VR_MODE);
  }

  // temporary added to exclude chrome 80+ with using
  if (getChromeVersion() >= 80) {
    disableFeature(Features.VR_MODE);
  }

  if ((gyroscopeSupportViaLocalStorage !== 'ON' && !supportsGyroscope) || !isVRCompatible()) {
    disableFeature(Features.VR_MODE);
  }
};
